import { createContext, useContext, type ReactNode } from "react";

/**
 * Rótulos acessíveis dos componentes base (I18N-APP-T14 / C-I18N-T14-6). Sem acoplamento ao LanguageContext: o default é o
 * texto atual ("Close"), então fora do /app (admin, público, login) nada muda. O AppLayout fornece o rótulo no idioma da UI.
 */
export type UiLabels = {
  close: string;
};

const DEFAULT_UI_LABELS: UiLabels = { close: "Close" };

const UiLabelsContext = createContext<UiLabels>(DEFAULT_UI_LABELS);

type UiLabelsProviderProps = {
  value: UiLabels;
  children: ReactNode;
};

export function UiLabelsProvider({ value, children }: UiLabelsProviderProps) {
  return <UiLabelsContext.Provider value={value}>{children}</UiLabelsContext.Provider>;
}

export function useUiLabels(): UiLabels {
  return useContext(UiLabelsContext);
}
